import styled, { css } from 'styled-components';
import moment from 'moment';
import { FormattedDate } from '../../common/utils/formatters';
const FundingStatuses = ['Requested', 'Scheduled', 'Funded'] as const;

/**
 * This weird type is a hack way to trick typescript into accepting
 * any string but still giving us the autocomplete for the FundingStatuses
 */
type TfundingStatus =
  | (typeof FundingStatuses)[number]
  | (string & Record<never, never>);

type TStatus = {
  fundingStatus: TfundingStatus;
  fundingStatusText: string;
  fundingDate?: string;
  disbursementDate?: string | null;
  buttonModalType?: string;
};

type TFundingStatus = {
  fundingStatus: TfundingStatus;
};

const FundingStatusText = styled.span<TFundingStatus>(
  ({ theme, fundingStatus }) => css`
    display: block;
    padding: 8px 0;
    color: ${theme.colors.main.font};
    font-size: ${theme.fonts.sizes.h6};
    font-weight: 500;
    text-align: center;
    background-color: ${theme.colors.lightWhiteSmoke};

    @media (max-width: ${theme.breakpoints.max.md}) {
      font-size: 0.75rem;
    }

    ${fundingStatus === 'Requested' &&
    css`
      color: ${theme.colors.fundingStatuses.requested.text};
      background-color: ${theme.colors.fundingStatuses.requested.background};
    `}
    ${fundingStatus === 'Scheduled' &&
    css`
      color: ${theme.colors.fundingStatuses.scheduled.text};
      background-color: ${theme.colors.fundingStatuses.scheduled.background};
    `}
    ${fundingStatus === 'Funded' &&
    css`
      color: ${theme.colors.fundingStatuses.done.text};
      background-color: ${theme.colors.fundingStatuses.done.background};
    `}
  `
);

const FundingStatusWrapper = styled.div(
  ({ theme }) => css`
    padding-right: 20px;
    padding-left: 10px;
    text-align: center;
    @media (max-width: ${theme.breakpoints.max.md}) {
      padding-right: 15px;
    }
  `
);

const FundingStatus = ({
  fundingStatus,
  fundingStatusText,
  fundingDate,
  disbursementDate,
  buttonModalType
}: TStatus) => {
  let overwriteStatus: string | false = false;
  if (disbursementDate) {
    const date = moment(disbursementDate, 'YYYY-MM-DD');
    const today = moment(new Date(), 'DD-MM-YYYY');

    if (today >= date) {
      if (buttonModalType === 'requestFund') {
        overwriteStatus = 'Funded';
      }
    }
  }

  return (
    <FundingStatusWrapper>
      <FundingStatusText fundingStatus={overwriteStatus || fundingStatus}>
        {overwriteStatus || fundingStatusText}
        <br />
        {fundingDate && (
          // Show disbursement date if in past else show funding date
          <FormattedDate
            date={
              overwriteStatus && disbursementDate
                ? disbursementDate
                : fundingDate
            }
          />
        )}
      </FundingStatusText>
    </FundingStatusWrapper>
  );
};
export { FundingStatus, type TFundingStatus };
